import Joi, { ObjectSchema } from "joi";
import {
  CardClass,
  Radius,
  Width,
  Border,
  ButtonBackground,
  ButtonText,
  ColorsButton,
  ColorsText,
  ColorsBackground,
  Colors,
  Typography,
  Spacing,
  Shadows,
  Borders,
  Animations,
  ExtendableProperties,
  Theme,
} from "../types";

const cardClassSchema: ObjectSchema<CardClass> = Joi.object({
  hover: Joi.string().required(),
  active: Joi.string().required(),
});

const radiusSchema: ObjectSchema<Radius> = Joi.object({
  small: Joi.string().required(),
  medium: Joi.string().required(),
  large: Joi.string().required(),
});

const widthSchema: ObjectSchema<Width> = Joi.object({
  thin: Joi.string().required(),
  thick: Joi.string().required(),
});

const borderSchema: ObjectSchema<Border> = Joi.object({
  default: Joi.string().required(),
  focus: Joi.string().required(),
});

const buttonBackgroundSchema: ObjectSchema<ButtonBackground> = Joi.object({
  primary: Joi.string().required(),
  secondary: Joi.string().required(),
  hover: Joi.string().required(),
});

const buttonTextSchema: ObjectSchema<ButtonText> = Joi.object({
  primary: Joi.string().required(),
  secondary: Joi.string().required(),
});

const colorsButtonSchema: ObjectSchema<ColorsButton> = Joi.object({
  background: buttonBackgroundSchema.required(),
  text: buttonTextSchema.required(),
});

const colorsTextSchema: ObjectSchema<ColorsText> = Joi.object({
  primary: Joi.string().required(),
  secondary: Joi.string().required(),
  link: Joi.string().required(),
  linkHover: Joi.string().required(),
});

const colorsBackgroundSchema: ObjectSchema<ColorsBackground> = Joi.object({
  body: Joi.string().required(),
  header: Joi.string().required(),
  footer: Joi.string().required(),
  card: Joi.string().required(),
});

const colorsSchema: ObjectSchema<Colors> = Joi.object({
  primary: Joi.string().required(),
  secondary: Joi.string().required(),
  background: colorsBackgroundSchema.required(),
  text: colorsTextSchema.required(),
  border: borderSchema.required(),
  button: colorsButtonSchema.required(),
});

const typographySchema: ObjectSchema<Typography> = Joi.object({
  fontFamily: Joi.object({
    base: Joi.string().required(),
    heading: Joi.string().required(),
  }).required(),
  fontSize: Joi.object({
    base: Joi.string().required(),
    small: Joi.string().required(),
    large: Joi.string().required(),
  }).required(),
});

const spacingSchema: ObjectSchema<Spacing> = Joi.object({
  padding: radiusSchema.required(),
  margin: radiusSchema.required(),
});

const shadowsSchema: ObjectSchema<Shadows> = Joi.object({
  card: Joi.string().required(),
  button: Joi.string().required(),
  hover: Joi.string().required(),
});

const bordersSchema: ObjectSchema<Borders> = Joi.object({
  radius: radiusSchema.required(),
  width: widthSchema.required(),
});

const animationsSchema: ObjectSchema<Animations> = Joi.object({
  button: cardClassSchema.required(),
  card: cardClassSchema.required(),
});

const extendablePropertiesSchema: ObjectSchema<ExtendableProperties> =
  Joi.object({
    customComponentStyles: Joi.object().required(),
  });

const themeSchema: ObjectSchema<Theme> = Joi.object({
  id: Joi.string().required(),
  name: Joi.string().required(),
  colors: colorsSchema.required(),
  typography: typographySchema.required(),
  spacing: spacingSchema.required(),
  shadows: shadowsSchema.required(),
  borders: bordersSchema.required(),
  animations: animationsSchema.required(),
  extendableProperties: extendablePropertiesSchema.required(),
});

export default themeSchema;
